import styled from 'styled-components';

export default styled.section`
  padding: 2.1875rem ${props => props.theme.padding.inner} 7.25rem;
  min-height: 500px;
  background: ${props => props.theme.colors.white};

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    padding: 2.75rem ${props => props.theme.padding.inner} 6.9375rem;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 3.375rem ${props => props.theme.padding.inner} 4.9375rem;
  }

  .inner {
    max-width: ${props => props.theme.maxWidths.containerSmall};
    margin: -11px auto;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;

    > p.type-h2 {
      margin: auto;
      animation: fadeIn 0.4s forwards;
    }

    .dealer_card {
      margin: 11px 0;
      box-shadow: ${props => props.theme.shadows.tooltip};

      .dealer_name {
        font-weight: 600;
      }

      @media (prefers-reduced-motion: no-preference) {
        opacity: 0;
        transform: translateY(10px);
        animation: dealerCardFadeIn 0.4s forwards;
        animation-duration: 0.4s;
      }
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
      flex-direction: row;
      flex-wrap: wrap;

      .dealer_card {
        width: calc(25% - 22px);
        margin: 11px;

        &:nth-child(4n + 1) {
          margin-left: 0;
        }

        &:nth-child(4n + 4) {
          margin-right: 0;
        }
      }
    }
  }

  @keyframes dealerCardFadeIn {
    0% {
      opacity: 0;
      transform: scale(1.1);
    }
    100% {
      transform: none;
      opacity: 1;
    }
  }

  ${props => props.theme.animations.fadeIn}
`;
